module.exports = __webpack_public_path__ + "static/img/成功案例4.e2e4b33.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/成功案例4.png
// module id = lHij
// module chunks = 1